import { Hash } from "lucide-react";
import { ColumnTableWrapper } from "./ColumnTableWrapper";

interface IdentifierColumnTableProps {
  identifier: string | number;
}

export function IdentifierColumnTable({ identifier }: IdentifierColumnTableProps) {
  return <ColumnTableWrapper className="font-medium text-primary">{identifier}</ColumnTableWrapper>;
}
